import React from "react"
import Landing from "../components/Phishing/Landing";
import Stats from "../components/Phishing/Stats";
import Features from "../components/Phishing/Features";
import Brief from "../components/Phishing/Brief";
import Banner from "../components/Phishing/Banner";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";


const Phishing = () => {

    return(
        <>
        <Navbar />
        <Landing />
        <Stats />
        <Features />
        <Brief />
        <Banner />
        <Footer />
        </>
    )
}
export default Phishing;